module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-popover', _vm._g(_vm._b({
    attrs: {
      "popper-class": _vm.computedPopperClass
    }
  }, 'el-popover', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "popover-image"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("reference", null, {
    "slot": "reference"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0330fa1b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/popover/rtPopover.vue
// module id = 2009
// module chunks = 228